<template>
	<modal
		name="sign-up-modal"
		:click-to-close="true"
		height="auto"
		@before-close="beforeClose"
		@opened="modalOpened"
		:scrollable="true"
		:adaptive="true"
	>
		<div
			id="sign-up-modal"
			role="dialog"
			aria-labelledby="sign-up-modal-label"
			aria-hidden="true"
		>
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<button
							@click="closeSignUpModal()"
							type="button"
							class="close text-white text-light"
							aria-label="Close"
						>
							<i class="modal-close"/>
						</button>
					</div>

					<div class="modal-body text-light">
						<h3 class="modal-title text-white m-b" id="sign-up-modal-label">SIGN UP</h3>
						<form @submit.prevent="signUp()" id="sign-up-form">
							<div class="form">
								<div class="form-group field">
									<input
										v-model.trim="username"
										v-validate="'required|min:4|max:16'"
										placeholder="Username"
										data-vv-validate-on="change"
										type="text"
										class="form-control"
										:class="{'input': true, 'danger': errors.has('username') }"
										name="username"
									>
									<span v-show="errors.has('username')" class="vv-error-message">{{ errors.first('username') }}</span>
								</div>
								<div class="form-group field">
									<!-- We need to fake these fields to avoid the Chrome autofill in the real fields-->
									<input
										style="display: none;"
										type="email"
										name="email"
										id="fake-email-field-2"
									>
									<input
										style="display: none;"
										type="text"
										name="password"
										id="fake-password-field-2"
									>


									<input
										v-model.trim.lazy="email"
										placeholder="Email Address"
										type="email"
										class="form-control"
										data-vv-validate-on="change"
										v-validate="'required|email|min:5'"
										:class="{'input': true, 'danger': errors.has('email') }"
										name="email"
									>
									<span v-show="errors.has('email')" class="vv-error-message">{{ errors.first('email') }}</span>
								</div>
								<div class="form-group input-group field">
									<div class="col-xs-12 col-md-6 p-l-0">
										<template>
											<input
												v-model="password"
												placeholder="Password"
												type="password"
												name="password"
												ref="password"
												title=""
												data-vv-validate-on="change"
												v-validate="{ required: true, regex: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{6,}/ }"
												class="form-control input-group js-input-password"
											>
										</template>
										<span v-show="errors.has('password')" class="vv-error-message">{{ errors.first('password') }}</span>
									</div>

									<div class="col-xs-12 col-md-6 p-a-0">
										<template>
											<input
												v-model="confirm"
												placeholder="Confirm Password"
												type="password"
												name="confirm-password"
												data-vv-as="confirm password"
												data-vv-validate-on="change"
												v-validate="'required|confirmed:password'"
												class="form-control input-group js-input-password"
											>
										</template>
										<span v-show="errors.has('confirm-password')" class="vv-error-message">
											{{ errors.first('confirm-password') }}
										</span>
									</div>
								</div>
								<div class="validate m-t-md">
									<p class="must-have text-white">Password must contain at least 6 characters, including upper + lowercase and numbers</p>
								</div>
								<div class="form-group input-group field">
									<multiselect
										id="sign-up-country-selection"
										v-model="country"
										:allow-empty="false"
										:options="countries"
										:searchable="true"
										label="countryName"
										placeholder="Select a location"
										select-label=""
										selected-label=""
										deselect-label=""
									/>
								</div>
							</div>

							<div class="checkbox checkbox-purple m-t m-b">
								<input id="checkbox1" type="checkbox" v-model="signup_for_newsletter">
								<label for="checkbox1" class="text-white  text-normal">
									OPT IN TO RECEIVE OUR NZXT NEWSLETTER
								</label>
							</div>
							<div class="checkbox checkbox-purple m-t m-b">
								<input id="checkbox2" type="checkbox" v-model="signup_for_newsletter_bld">
								<label for="checkbox2" class="text-white  text-normal">
									OPT IN TO RECEIVE OUR BLD NEWSLETTER
								</label>
							</div>
							<div class="checkbox checkbox-purple m-t m-b">
								<input id="checkbox3" type="checkbox" v-model="signup_for_newsletter_cam">
								<label for="checkbox3" class="text-white  text-normal">
									OPT IN TO RECEIVE OUR CAM NEWSLETTER
								</label>
							</div>


							<div class="acc-form register-btn m-t-md">
								<button class="btn btn-white btn-outline" type="submit" :disabled="isSigningUp">
									<template v-if="isSigningUp">
										SIGNING UP...
									</template>
									<template v-else>
										SIGN UP
									</template>
								</button>
								<a class="btn btn-white btn-outline" @click="onSignIn()" :disabled="isSigningUp">SIGN IN HERE
								</a>
							</div>

							<div class="acc-form social-btn">
								<a :href="`${googleSocialLoginUrl}?continue=${returnUrl}`" class="btn  btn-gmail"> <i class="gplus"/>  Sign in with Google</a>
								<a :href="`${fbSocialLoginUrl}?continue=${returnUrl}`" class="btn btn-facebook"> <i class="facebook"/> Sign in with Facebook</a>
							</div>
						</form>
					</div>
					<div class="modal-footer bg-white">
						<img src="/images/icons/nzxt-logos.png" alt="NZXT logos">
						<p class="m-t m-b-0">
							BY SIGNING UP OR LOGGING IN, YOU AGREE TO NZXT, CAM, AND BLD'S
							<a href="https://www.nzxt.com/terms-of-service" class="text-purple" target="_blank">TERMS & CONDITIONS</a>
							AND <a href="https://www.nzxt.com/privacy-policy" class="text-purple" target="_blank">PRIVACY POLICY</a>
						</p>
					</div>
				</div>
			</div>
		</div>
	</modal>
</template>

<script>
import { Validator } from "vee-validate";
import { helpers } from "../../util/mixins";

export default {
	name: "SignUpModal",
	mixins: [helpers],
	data() {
		return {
			returnUrl: process.env.MIX_URL,
			googleSocialLoginUrl: process.env.MIX_NZXT_GOOGLE_SOCIAL_LOGIN,
			fbSocialLoginUrl: process.env.MIX_NZXT_FB_SOCIAL_LOGIN,
			username: "",
			email: "",
			password: "",
			confirm: "",
			country: {
				countryCode: "",
				countryName: ""
			},
			countries: [],
			isSigningUp: false,
			signup_for_newsletter: true,
			signup_for_newsletter_bld: false,
			signup_for_newsletter_cam: false,
			isProduction: CONFIG.PRODUCTION,
			isOpen: false,
			userLocationFeched: false

		};
	},
	watch: {
		isOpen(isOpen) {
			if (isOpen && !this.userLocationFeched) {
				this.getUserLocalization();
			}
		}
	},
	mounted() {
		this.setupValidationMessages();

		this.countries = Object.keys(nzxt.countries).map(countryCode => {
			return {
				countryCode,
				countryName: nzxt.countries[countryCode]
			};
		});
	},
	methods: {
		modalOpened() {
			this.isOpen = true;
		},
		beforeClose() {
			this.isOpen = false;
			this.username = "";
			this.email = "";
			this.password = "";
			this.confirm = "";
			this.signup_for_newsletter = true;
			this.signup_for_newsletter_bld = false;
			this.signup_for_newsletter_cam = false;
			this.$validator.reset();
		},
		onSignIn() {
			this.closeSignUpModal();
			this.$modal.show("login-modal");
		},
		setupValidationMessages() {
			const dictionary = {
				en: {
					custom: {
						username: {
							required: "Please enter in a username.",
							min: "Your Username must be at least 4 characters long.",
							max: "Your Username cannot exceed 16 characters long."
						},
						password: {
							regex: () => {
								if (!this.password) {
									return "Please enter in a password.";
								} else if (!this.password.match(/^.{6,}$/g)) {
									return "Please enter in a password 6 characters or longer for your own security.";
								} else if (!this.password.match(/\d/g)) {
									return "Password must include a number.";
								} else if (!this.password.match(/(?=.*[a-z])/g)) {
									return "Password must include an lowercase letter.";
								} else if (!this.password.match(/(?=.*[A-Z])/g)) {
									return "Password must include an uppercase letter.";
								}
							}
						},
						email: {
							required: "You must enter in your email address in order to register."
						},
						"confirm-password": {
							required: "You must confirm your password!",
							confirmed: "Your passwords does not match, please try again."
						}
					}
				}
			};

			Validator.localize(dictionary);
		},
		async getUserLocalization() {
			const { data: location } = await axios("/location");
			this.country = this.countries.find(country => {
				return location.country_code === country.countryCode;
			});
			this.userLocationFeched = true;
		},
		successHandler: function(user) {
			EventBus.$emit("user-signed-in", user);
			this.isSigningUp = false;
			_learnq.push(["track", "Signed Up"]);

			if (window.location.pathname.toUpperCase() == "/BLD") {
				window.save_bld();
			}
		},
		errorHandler() {
			this.isSigningUp = false;
		},
		async signUp() {
			this.isSigningUp = true;
			let isValid = await this.$validator.validateAll();

			if (!isValid) {
				this.isSigningUp = false;
				return;
			}

			try {
				// We wait until all the promises finish to make sure
				// that the username and email are available
				await this.checkUsernameAvailability();
				await this.checkEmailAvailability(false);
			} catch (error) {
				this.isSigningUp = false;
				return;
			}

			isValid = await this.$validator.validateAll();

			if (!isValid) {
				this.isSigningUp = false;
				return;
			}

			const formData = new FormData();
			formData.append("username", this.username);
			formData.append("email", this.email);
			formData.append("password", this.password);
			formData.append("country", this.country.countryCode);
			formData.append("signup_for_newsletter", Number(this.signup_for_newsletter));
			formData.append("signup_for_newsletter", Number(this.signup_for_newsletter_bld));
			formData.append("signup_for_newsletter", Number(this.signup_for_newsletter_cam));

			axios({
				url: "/auth/signup",
				method: "POST",
				data: formData
			}).then(user => {
				if (user.message) {
					this.errorHandler(user.data);
				} else {
					this.successHandler(user.data);
				}
			}).catch(error => {
				this.errorHandler(error.data);
			});
		},
		emailAvailability: async function() {
			const email = new FormData();
			email.append("email", this.email);
			return axios({
				url: "/auth/validate-email",
				method: "POST",
				data: email
			});
		},
		async checkEmailAvailability(async = true) {
			if (this.email) {
				const availability = await this.emailAvailability();
				const error = {
					field: "email",
					msg: "This email has already been registered."
				};
				if (!availability.data.available) {
					this.$validator.errors.add(error);
					$("[name=email]").focus();
					throw new Error(error.msg);
				} else {
					if (async) {
						this.$validator.errors.remove("email");
					}
				}
			}
		},
		usernameAvailability: async function() {
			const username = new FormData();
			username.append("username", this.username);

			return axios({
				url: "/auth/validate-username",
				method: "POST",
				data: username
			});
		},
		async checkUsernameAvailability() {
			if (this.username) {
				const availability = await this.usernameAvailability();

				const error = {
					field: "username",
					msg: "Sorry, this username has already been taken."
				};
				if (!availability.data.available) {
					this.$validator.errors.add(error);
					$("[name=username]").focus();
					throw new Error(error.msg);
				} else {
					this.$validator.errors.remove("username");
				}
			}
		},
		goTo(url) {
			$(".modal").modal("hide");
			this.$router.push(url);
		},
		closeSignUpModal() {
			this.$modal.hide("sign-up-modal");
		}
	}
};
</script>

<style lang="scss">
.v--modal-overlay[data-modal="sign-up-modal"] {
    background-color: rgba(0, 0, 0, 0.65);

    .v--modal-box {
        background-color: transparent;
        max-width: 100%;
    }

    .v--modal {
        background-color: transparent;
        box-shadow: none;
    }

    .vv-error-message {
        font-size: 13px;
        line-height: 20px;
        text-align: left;
        color: red;
    }

    .modal-dialog {
        top: -130px;
        @media screen and (max-width: 680px) and (min-width: 320px) {
            top: -46px !important;
        }
    }
}

#sign-up-modal {
    padding: 0 15px !important;

    .modal-body {
        @media screen and (max-width: 450px) {
            padding: 0 30px 30px;
        }
    }

    .multiselect {
        color: white;
        font-size: 20px;
        border-bottom: 2px solid white;
        outline: none;
        cursor: pointer;

        &--active {
            cursor: default;
        }


        &__tags {
            background: transparent;
            border: none;
            padding: 15px 40px 0 2px;
        }

        &__single {
            background: transparent;
            font-size: 20px;
            font-family: "Akkurat-Normal", sans-serif;
            margin-bottom: 0;
        }

        &__select {
            right: -7px;

            &:before {
                top: 100%;
            }
        }

        &__option {
            color: #51017A;
            font-weight: 700;
            font-size: 16px;

            &--highlight {
                background: #51017A;
                color: white;
            }
        }
    }

    ::placeholder {
        color: darken($color: #fff, $amount: 10%);
    }

    .must-have {
        margin-bottom: 0;
    }
}

.modal-dialog {
    top: -130px;
    @media screen and (max-width: 680px) and (min-width: 320px) {
        top: -46px !important;
    }
}

.vv-error-message {
    font-size: 13px;
    line-height: 20px;
    text-align: left;
    color: red;
}
</style>
